import Base from "../Step.es6";

// Edit users image
export default class extends Base {
    constructor(Configurator) {
        super('selector', Configurator.mode.DESIGN_HASH, Configurator);
        this.url            = 'selector' + '/?upload=' + App.Variable('allowImageUpdate');
        this.level          = Configurator.PURCHASE_LEVEL_HIGH;
        this.overlay        = this.Configurator.Overlay.CONTAINER_INLINE;
        this.main           = true;
        this.useVI          = false; // Do not use view interface
        this.stopOnSubmit   = false;
        this.values         = {
            id: null,
        };
    }
    validate() {
        return this.ready && this.values.id && this.Configurator.id;
    }
    commit(id) {
        this.Configurator.id    = id;
        this.values.id          = id;
        this.level              = this.Configurator.PURCHASE_LEVEL_LOW;
        return this;
    }
    remove() {
        this.Configurator.id    = null;
        this.values.id          = null;
        this.ready              = false;
        return this;
    }
    run() {
        return this;
    }
}
